import React, {Dispatch, useState} from "react"
import {IEmployee} from "../../../../models/employee"
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux"
import useWindowSize from "../../../../hooks/useWindowSize"
import LineMenu from "../LineMenu"
import Modal from "../../modals/Modal"
import {deleteEmployee, fetchEmployees, setCurrentPage} from "../../../../store/actions/employeeActions"
import ModalEditEmployee from "../../modals/ModalEditEmployee/ModalEditEmployee"
import StatusLabel from "../../../generic/dataDisplay/StatusLabel"
import {USER_ROLE_DRIVER, USER_ROLE_MANAGER} from "../../../../utils/constants/userRoles"
import classes from "./EmployeeLine.module.scss"

interface IEmployeeLineProps {
  item: IEmployee,
  editSuccess: Dispatch<any>
  deleteSuccess: Dispatch<any>
}

export default function EmployeeLine({item, editSuccess, deleteSuccess}: IEmployeeLineProps) {

  const dispatch = useAppDispatch()
  const windowSize = useWindowSize()
  const {employeeRoles} = useAppSelector(state => state.handbook)
  const {role_id} = useAppSelector(state => state.auth.user)
  const {pageSize} = useAppSelector(state => state.employee)
  const [modalEditShown, modalEditToggle] = useState(false)
  const [modalDeleteShown, modalDeleteToggle] = useState(false)
  const isDriverItem = item.role_id === USER_ROLE_DRIVER
  const isManagerItem = item.role_id === USER_ROLE_MANAGER
  const userIsManager = role_id === USER_ROLE_MANAGER

  const deleteHandler = async () => {
    const isDeleted = await dispatch(deleteEmployee(item.user_uuid))

    if (isDeleted) {
      modalDeleteToggle(false)
      deleteSuccess(true)
      dispatch(setCurrentPage(1))
      await dispatch(fetchEmployees({page: 1, pageSize}))
    }
  }

  const modalEdit = modalEditShown &&
    <ModalEditEmployee
      close={modalEditToggle}
      editSuccess={editSuccess}
      editableItem={item}
    />

  const modalDelete = modalDeleteShown &&
    <Modal
      title={"Удалить сотрудника?"}
      close={() => modalDeleteToggle(false)}
      dialogSizeSuffix={"w350"}
      submitClick={deleteHandler}
      submitText={"Да, удалить"}
      cancelClick={() => modalDeleteToggle(false)}
      headerAlignCenter={true}
    />

  const menuList = [
    {
      id: 1,
      text: "Редактировать",
      onClick: () => modalEditToggle(true)
    },
    {
      id: 2,
      text: "Удалить",
      type: "delete",
      onClick: () => modalDeleteToggle(true)
    }
  ]

  return (
    <>
      <div className={classes.wrap}>
        <div className={[classes.field, classes.field_name].join(" ")}>
          <div className={classes.field_value_name}>{item.fio}</div>
          {windowSize.width < 992 &&
            <div className={classes.field_value_role}>{employeeRoles[item.role_id]}</div>
          }
        </div>
        {windowSize.width >= 768 && <div className={[classes.field, classes.field_phone].join(" ")}>
          {windowSize.width < 992 &&
            <div className={classes.field_label}>Телефон:</div>
          }
          <div className={classes.field_value_phone}>{item.phone}</div>
        </div>}
        {windowSize.width >= 992 && <div className={classes.field}><span>{employeeRoles[item.role_id]}</span></div>}
        <div className={[classes.field, classes.field_brigade].join(" ")}>
          {windowSize.width < 992 &&
            <div className={classes.field_label}>Бригада:</div>
          }
          <div className={classes.field_value_brigade}>{item.brigade.name ? item.brigade.name : "—"}</div>
        </div>
        <div className={[classes.field, classes.field_status].join(" ")}>
          {isDriverItem ? <StatusLabel id={item.status_id} type={"employee"}/> : `—`}
        </div>
        <div className={[classes.field, classes.field_menu].join(" ")}>
          <LineMenu disabled={isManagerItem && userIsManager} items={menuList}/>
        </div>
      </div>
      {modalEdit}
      {modalDelete}
    </>
  )
}